<br>
<div class="table-container none-vig-aux">
    <div class="spinner" *ngIf="isLoading">
        <mat-spinner color="accent"></mat-spinner>
    </div>
    <ng-container *ngIf="existente && fotos?.length>0" >
        <div class="polaroid">
            <div class="image" style="background-image: url({{hostapi}}/{{group.value}})"></div>
        </div>
        <div class="text-align-center">
            <mat-button-toggle-group #group="matButtonToggleGroup" aria-label="Font Style" >
                <mat-button-toggle value="{{fotos[1].activa}}" [checked]="true">Foto 1</mat-button-toggle>
                <mat-button-toggle value="{{foto.foto}}" *ngFor="let foto of fotos[0].hist; let i=index">Foto {{i + 2}}</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </ng-container>
    <br>

    <form [formGroup]="formulario" autocomplete="off">
        <mat-form-field appearance="fill" class="bt col-md-8 none-vig-aux">
            <mat-label>Nombre de la Beneficiaria</mat-label>
            <input matInput placeholder="" maxlength="100" #nombre formControlName="nombre" [value]="beneficiaria?.nombre">
            <mat-hint align="end">{{nombre.value.length}} / 100</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-4 none-vig-aux">
            <mat-label>Fecha de Alta de Expediente</mat-label>
            <input matInput [matDatepicker]="dp1" formControlName="fechaAlta">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker touchUi #dp1 disabled="true"></mat-datepicker>
        </mat-form-field>
        <div>
            <mat-form-field appearance="fill" class="bt col-md-4 none-vig-aux">
                <mat-label>Fecha de Nacimiento</mat-label>
                <input matInput [matDatepicker]="dp2" formControlName="fechaNacimiento">
                <mat-datepicker-toggle matSuffix [for]="dp2"></mat-datepicker-toggle>
                <mat-datepicker startView="multi-year" touchUi #dp2 disabled="true"></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill" class="bt col-md-2 none-vig-aux" >
                <mat-label>Edad</mat-label>
                <input matInput placeholder="" readonly [value]="edad" disabled>
            </mat-form-field>
        
            <!--<mat-form-field appearance="fill" class="bt col-md-4">
                <mat-label>Fecha de ingreso</mat-label>
                <input matInput [matDatepicker]="dp3" formControlName="fechaIngreso" [value]="beneficiaria?.fechaIngreso" readonly>
                <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                <mat-datepicker touchUi #dp3 disabled="true"></mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="fill" class="bt col-md-2">
                <mat-label>Edad de ingreso</mat-label>
                <input matInput placeholder="" readonly [value]="edadIngreso">
            </mat-form-field>

            <mat-form-field appearance="fill" class="bt col-md-2">
                <mat-label>Tiempo de antiguedad</mat-label>
                <input matInput placeholder="" readonly [value]="tiempoDeAntiguedad">
            </mat-form-field>-->
        </div>
        <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
            <mat-label>CURP</mat-label>
            <input matInput placeholder="" formControlName="idCurp" maxlength="18" [value]="beneficiaria?.idCurp">
        </mat-form-field>

        <div>
            <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
                <mat-label>Canaliza</mat-label>
                <mat-select formControlName="idCanaliza">
                    <mat-option *ngFor="let org of canaliza" value="{{org.idParametro}}">{{org.valor}}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux" *ngIf="vig_tiene__Bandera_(form.idCanaliza?.value,canaliza)">
                <mat-label>Especificar</mat-label>
                <input type="text" matInput formControlName="desCanaliza">
            </mat-form-field>
        </div>
        <div>
            <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
                <mat-label>Motivo de Ingreso</mat-label>
                <mat-select formControlName="idMotivoIngreso">
                    <mat-option value="{{motivo.idParametro}}" *ngFor="let motivo of motivoIngreso" >{{motivo.valor}}</mat-option>
                </mat-select>
            </mat-form-field>
            
            <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux" *ngIf="vig_tiene__Bandera_(form.idMotivoIngreso.value,motivoIngreso)">
                <mat-label>Especificar</mat-label>
                <input type="text" matInput formControlName="desMotivoIngreso">
            </mat-form-field>
        </div>
        <mat-form-field appearance="fill" class="bt col-md-12 none-vig-aux" >
            <mat-label>Historia Detallada</mat-label>
            <textarea matInput placeholder="" maxlength="2500" #historia formControlName="desHitoria"></textarea>
            <mat-hint align="start"><strong></strong> </mat-hint>
            <mat-hint align="end">{{historia.value.length}} / 2500</mat-hint>
        </mat-form-field>

        <h3>Perfil diagnóstico previo</h3>

        <div>
            <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
                <mat-label>Discapacidad</mat-label>
                <mat-select formControlName="idDiscapacidad" multiple #discapacidadesf>
                <mat-select-trigger>
                    {{discapacidadesf.value ? discapacidadesf.value[0] : ''}}
                    <span *ngIf="discapacidadesf.value?.length > 1" class="example-additional-selection">
                    (+{{discapacidadesf.value.length - 1}} {{discapacidadesf.value?.length === 2 ? 'más' : 'más'}})
                    </span>
                </mat-select-trigger>
                <mat-option *ngFor="let discapacidad of discapacidades" [value]="discapacidad">{{discapacidad}}</mat-option>
                </mat-select>
            </mat-form-field>      
        </div>
        <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
            <mat-label>Diagnóstico Neurológico Previo</mat-label>
            <mat-select formControlName="diagnosticoNeurologico">
                <mat-option value="{{dn.idParametro}}" *ngFor="let dn of diagnosticoNeurologico" disabled>{{dn.valor}}</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
            <mat-label>Documento Diagnóstico Neurológico</mat-label>
            <input matInput placeholder="Adjuntar JPG, PDF" [value]="archivo.value" formControlName="dnRuta" readonly>
            <button mat-icon-button matSuffix type="button" disabled>
                <mat-icon>attach_file</mat-icon>
            </button>
            <input type="file" #archivo class="hide" formControlName="dnArchivo"/>
            
            <a href="{{hostapi}}/{{documento1}}" *ngIf="documento1" target="_blank" rel="noopener" matTooltip="Click para ver el documento cargado" color="accent" mat-icon-button matPrefix type="button" >
                <mat-icon>download</mat-icon>
            </a>
            <mat-hint *ngIf="documento1">Ya Existe un Documento Cargado</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-12 none-vig-aux">
            <mat-label>Descripción</mat-label>
            <textarea matInput placeholder="" maxlength="150" #descripcion formControlName="dnDescripcion"></textarea>
            <mat-hint align="end">{{descripcion.value.length}} / 150</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
            <mat-label>Edad Mental Previo</mat-label>
            <input matInput placeholder="" type="number" maxlength="2" formControlName="edadMental">
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
            <mat-label>Documento Edad Mental</mat-label>
            <input matInput placeholder="Adjuntar JPG, PDF" [value]="archivo2.value" formControlName="dmRuta" readonly>
            <button mat-icon-button matSuffix type="button" disabled>
                <mat-icon>attach_file</mat-icon>
            </button>
            <input type="file" #archivo2 class="hide" formControlName="emArchivo"/>
            
            
            <a href="{{hostapi}}/{{documento2}}" *ngIf="documento2" target="_blank" rel="noopener" matTooltip="Click para ver el documento cargado" color="accent" mat-icon-button matPrefix type="button" >
                <mat-icon>download</mat-icon>
            </a>
            <mat-hint *ngIf="documento2">Ya Existe un Documento Cargado</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
            <mat-label>Diagnóstico Motríz Previo</mat-label>
            <input matInput placeholder="" maxlength="150" #motriz formControlName="diagnosticoMotriz">
            <mat-hint align="end">{{motriz.value.length}} / 150</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
            <mat-label>Documento Diagnóstico Motríz</mat-label>
            <input matInput placeholder="Adjuntar JPG, PDF" [value]="archivo3.value" formControlName="dmRuta" readonly>
            <button mat-icon-button matSuffix type="button" disabled>
                <mat-icon>attach_file</mat-icon>
            </button>
            <input type="file" #archivo3 class="hide" formControlName="dmArchivo"/>
            
            
            <a href="{{hostapi}}/{{documento3}}" *ngIf="documento3" target="_blank" rel="noopener" matTooltip="Click para ver el documento cargado" color="accent" mat-icon-button matPrefix type="button" >
                <mat-icon>download</mat-icon>
            </a>
            <mat-hint *ngIf="documento3">Ya Existe un Documento Cargado</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
            <mat-label>Diagnóstico Psicológico Previo</mat-label>
            <input matInput placeholder="" maxlength="150" #psicologico formControlName="diagnosticoPsicologico">
            <mat-hint align="end">{{psicologico.value.length}} / 150</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
            <mat-label>Documento Diagnóstico Psicológico</mat-label>
            <input matInput placeholder="Adjuntar JPG, PDF" [value]="archivo4.value" formControlName="dpRuta" readonly>
            <button mat-icon-button matSuffix type="button" disabled>
                <mat-icon>attach_file</mat-icon>
            </button>
            <input type="file" #archivo4 class="hide" formControlName="dpArchivo"/>
            

            <a href="{{hostapi}}/{{documento4}}" *ngIf="documento4" target="_blank" rel="noopener" matTooltip="Click para ver el documento cargado" color="accent" mat-icon-button matPrefix type="button" >
                <mat-icon>download</mat-icon>
            </a>
            <mat-hint *ngIf="documento4">Ya Existe un Documento Cargado</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
            <mat-label>Diagnóstico Médico Previo</mat-label>
            <input matInput placeholder="" maxlength="150" #medico formControlName="diagnosticoMedico">
            <mat-hint align="end">{{medico.value.length}} / 150</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="bt col-md-6 none-vig-aux">
            <mat-label>Documento Diagnóstico Médico</mat-label>
            <input matInput placeholder="Adjuntar JPG, PDF" [value]="archivo5.value" formControlName="dmedRuta" readonly>
            <button mat-icon-button matSuffix type="button" disabled>
                <mat-icon>attach_file</mat-icon>
            </button>
            <input type="file" #archivo5 class="hide" formControlName="dmedArchivo"/>
            
            
            <a href="{{hostapi}}/{{documento5}}" *ngIf="documento5" target="_blank" rel="noopener" matTooltip="Click para ver el documento cargado" color="accent" mat-icon-button matPrefix type="button" >
                <mat-icon>download</mat-icon>
            </a>
            <mat-hint *ngIf="documento5">Ya Existe un Documento Cargado</mat-hint>
        </mat-form-field>

        <br><br>
        <div class="text-align-center">
            <button type="button" class="flat" color="primary" mat-flat-button [routerLink]="['/beneficiarias']" style="margin-right: 15px;">Cancelar</button>
        </div>
    </form>
</div>